import { Capacitor } from '@capacitor/core';

import { Acknowledgement } from '../../../../types/user.types';
import { legalDocTypeCodesToNameMap, legalDocType } from '../../config';
import { checkIfAcknowledgeAfterLegalDocModification } from '../../helpers/helpers';
import { LegalDocument } from '../../types/State.types';

const getLegalDocument = ({
  docsList,
  acknowledgements,
  type,
  termsOfUseToAcknowledge,
  privacyPolicyToAcknowledge,
  version,
}: {
  docsList?: LegalDocument[];
  acknowledgements?: Acknowledgement[];
  type: string;
  termsOfUseToAcknowledge?: string;
  privacyPolicyToAcknowledge?: string;
  version: string;
}) => {
  let currentDocsId: { [key: string]: string } = {};
  if (docsList)
    docsList.forEach(
      (doc) =>
        (currentDocsId[
          legalDocTypeCodesToNameMap[doc.type.value as keyof typeof legalDocTypeCodesToNameMap]
        ] = doc.id)
    );

  let acknowledgedDocsId: { [key: string]: string } = {};
  let lastAcknowledgedOn: { [key: string]: number } = {};

  //warning: this will bug for users traveling between geographies because there is no guarantee that it is for the same geography. geography should be returned by the API for each acknowledgement
  if (acknowledgements) {
    acknowledgements.forEach((acknowledgement) => {
      let typeCode = acknowledgement.type.value;
      let documentType =
        legalDocTypeCodesToNameMap[typeCode as keyof typeof legalDocTypeCodesToNameMap];
      let acknowledgedOn = acknowledgement.acknowledgedOn;
      let documentId = acknowledgement.documentId;
      let candidateAcknowledgedOn = Date.parse(acknowledgedOn);
      if (
        acknowledgedDocsId[documentType as keyof typeof acknowledgedDocsId] === undefined ||
        candidateAcknowledgedOn >
          lastAcknowledgedOn[documentType as keyof typeof lastAcknowledgedOn]
      ) {
        acknowledgedDocsId[documentType as keyof typeof acknowledgedDocsId] = documentId;
        lastAcknowledgedOn[documentType as keyof typeof lastAcknowledgedOn] =
          Date.parse(acknowledgedOn);
      }
    });
  }

  let shouldAcknowledge = false;
  let documentId = currentDocsId[type];
  const skipTermOfUseOnWeb = !Capacitor.isNativePlatform() && type === legalDocType.terms_of_use;
  if (version === 'current' && !skipTermOfUseOnWeb) {
    //check if the doc should be acknowledged
    if (
      (type === legalDocType.terms_of_use && termsOfUseToAcknowledge) ||
      (type === legalDocType.privacy_policy && privacyPolicyToAcknowledge)
    ) {
      shouldAcknowledge = true;
    }
  } else if (version === 'acknowledged' && skipTermOfUseOnWeb) {
    documentId = acknowledgedDocsId[type];
  }

  let isAcknowledgeAfterLegalDocModification = false;
  if (shouldAcknowledge) {
    isAcknowledgeAfterLegalDocModification = checkIfAcknowledgeAfterLegalDocModification(
      acknowledgements,
      type
    );
  }

  return {
    documentId,
    shouldAcknowledge,
    isAcknowledgeAfterLegalDocModification,
  };
};

export { getLegalDocument };
